import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, defer } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { requestsInFlight } from 'src/shared/util/requests-in-flight';

/** Counts API requests in flight, so a chunk-load reload waits instead of cutting off a save (see chunk-load-recovery). */
@Injectable()
export class RequestsInFlightInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return defer(() => {
      const settle = requestsInFlight.start();
      return next.handle(request).pipe(finalize(settle));
    });
  }
}
